import styled from 'styled-components';
import theme from 'ui/theme';

export const ProductThumb = styled.li`
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: ${theme.space.xs} 0;
  margin: 0 ${theme.space.xxxs};

  &[data-disabled='true'] {
    cursor: default;
    pointer-events: none;
    opacity: 0.5;
  }

  &[data-selected='true'] {
    &::after {
      content: '';
      position: absolute;
      bottom: 1px;
      width: 60%;
      height: 2px;
      background: ${({ theme }) => theme.colors.grey[900]};
    }
  }
`;

export const ProductThumbMobile = styled.li`
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: ${theme.space.xxs} 0;
  border: 1px solid transparent;
  margin: 0 ${theme.space.xxxs};

  &[data-disabled='true'] {
    cursor: default;
    pointer-events: none;
    opacity: 0.5;
  }

  &[data-selected='true'] {
    border-color: black;
  }
`;

export const ThumbImage = styled.img`
  width: ${({ theme }) => theme.space.xxxl};
  height: ${({ theme }) => theme.space.xxxxl};
  padding-bottom: ${({ theme }) => theme.space.xs};
`;
